import React from "react";
import AssistantErrorHelp from "./AssistantErrorHelp";
import ChatGptDrawer from "./ChatGptDrawer";

/**
 * The 404 and 500 pages' "Ask the assistant". Those pages render outside the layout, where the
 * assistant's window is not mounted, so one is mounted here, out of sight: its palette is
 * portalled to the body and opens over the page. Kept apart from AssistantErrorHelp so the card
 * error state, which every Panel renders, does not pull the whole window in with it.
 */
const AssistantErrorPageHelp = ({ shown }) => (
    <>
        <AssistantErrorHelp shown={shown} windowMounted />
        <div hidden>
            <ChatGptDrawer />
        </div>
    </>
);

export default AssistantErrorPageHelp;
